// angular
import { Component, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pwj-mobile-sorts-sheet',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './mobile-sorts-sheet.component.html',
  styleUrl: './mobile-sorts-sheet.component.scss',
})
export class MobileSortsSheetComponent {
  sorts = input.required<string[]>();
  translateKey = input.required<string>();
  sortParamKey = input<string>('sort');
  isOpen = input(false);
  closed = output<void>();

  readonly activeSort = signal('');

  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  constructor() {
    this._route.queryParams.pipe(takeUntilDestroyed()).subscribe((params: Params) => {
      const raw = params[this.sortParamKey()];
      this.activeSort.set(typeof raw === 'string' ? raw.toUpperCase() : '');
    });
  }

  close(): void {
    this.closed.emit();
  }

  selectSort(sort: string): void {
    const selectedSort = sort.toUpperCase();
    const nextSort = this.activeSort() === selectedSort ? null : selectedSort;
    this._router.navigate([], {
      queryParams: {
        [this.sortParamKey()]: nextSort,
        page: null,
        perPage: null,
      },
      queryParamsHandling: 'merge',
    });
    this.closed.emit();
  }
}
